import CloseIcon from '@atlaskit/icon/core/close';
import { RovoIcon } from '@atlaskit/logo';
import { Button } from '@trello/nachos/button';
import { token } from '@trello/theme';

import styles from './RovoButton.less';

interface RovoButtonProps {
  isActive: boolean;
  onClick: () => void;
  triggerRef?: (node: HTMLElement | null) => void;
}

export const RovoButton = ({
  isActive,
  onClick,
  triggerRef,
}: RovoButtonProps) => {
  return (
    <Button className={styles.rovoButton} onClick={onClick} ref={triggerRef}>
      {!isActive ? (
        <RovoIcon label="Rovo" appearance="inverse" size="small" /> // TODO: i18n
      ) : (
        <CloseIcon
          label="Close" // TODO: i18n
          color={token('color.icon.inverse', '#ffffff')}
        />
      )}
    </Button>
  );
};
